module.exports = __webpack_public_path__ + "static/media/168.6eda4329.jpg";